import { FC } from 'react'
import Modal from '@common/Modal'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import sharedClasses from '@modals/index.module.css'
import { IcoRemove } from '@/utils/icons'
import AddContractForm from './AddContractForm'
import classes from './index.module.css'

export type StudentContractState = {
  id: number
  contracts?: unknown[]
} & Record<string, unknown>

type AddContractModalProps = {
  active?: boolean
  close?: () => void
  state: StudentContractState
  setState: (value: StudentContractState) => void
  onSuccess?: () => void
}

const AddContractModal: FC<AddContractModalProps> = ({
  active = true,
  close,
  state,
  setState,
  onSuccess,
}) => {
  if (!active) {
    return null
  }

  return (
    <Modal
      active={active}
      setActive={close}
      className={classes.modalWrapper as any}
      styleContent={{
        minWidth: 'auto',
        padding: 0,
      }}
    >
      <div className={sharedClasses.modalContainer}>
        <div className={sharedClasses.modalHeader}>
          <div className={sharedClasses.modalTitleContainer}>
            <span className={sharedClasses.modalHeaderBigTitle}>
              Добавить договор
            </span>
          </div>
          <div className={mclasses.closeIcon} onClick={close}>
            <IcoRemove />
          </div>
        </div>

        <AddContractForm
          state={state}
          setState={setState}
          close={close}
          onSuccess={onSuccess}
        />
      </div>
    </Modal>
  )
}

export default AddContractModal
